import React, { useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  Tabs,
  Tab,
  Snackbar,
  Alert
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SecurityIcon from '@mui/icons-material/Security';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BackupIcon from '@mui/icons-material/Backup';
import { useAppTheme } from '../../contexts/ThemeContext';

// Import sub-components
import CompanySettings from './CompanySettings';
import ProfileSettings from './ProfileSettings';
import NotificationSettings from './NotificationSettings';
import SecuritySettings from './SecuritySettings';
import BillingSettings from './BillingSettings';
import BackupSettings from './BackupSettings';

const Settings = () => {
  const { palette, Colors } = useAppTheme();
  const [tabValue, setTabValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const showNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{
          backgroundColor: palette.background.secondary,
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: `1px solid ${palette.border}`,
          p: 3
        }}>
          <Typography variant="h4" sx={{ color: Colors.primary.main, fontWeight: 'bold', mb: 0.5 }}>
            Settings
          </Typography>
          <Typography variant="body2" sx={{ color: palette.text.secondary }}>
            Manage your account and application preferences
          </Typography>
        </Box>
      </Box>

      <Paper sx={{
        mb: 3,
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        backgroundColor: palette.background.secondary,
        border: `1px solid ${palette.border}`,
      }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab icon={<BusinessIcon />} iconPosition="start" label="Company" />
          <Tab icon={<PersonIcon />} iconPosition="start" label="Profile" />
          <Tab icon={<NotificationsIcon />} iconPosition="start" label="Notifications" />
          <Tab icon={<SecurityIcon />} iconPosition="start" label="Security & Users" />
          <Tab icon={<ReceiptIcon />} iconPosition="start" label="Billing" />
          <Tab icon={<BackupIcon />} iconPosition="start" label="Backup & Restore" />
        </Tabs>
      </Paper>

      <Paper sx={{
        p: 3,
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        backgroundColor: palette.background.secondary,
        border: `1px solid ${palette.border}`,
      }}>
        {tabValue === 0 && <CompanySettings showNotification={showNotification} />}
        {tabValue === 1 && <ProfileSettings showNotification={showNotification} />}
        {tabValue === 2 && <NotificationSettings showNotification={showNotification} />}
        {tabValue === 3 && <SecuritySettings showNotification={showNotification} />}
        {tabValue === 4 && <BillingSettings showNotification={showNotification} />}
        {tabValue === 5 && <BackupSettings showNotification={showNotification} />}
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Settings;